<template>
  <div>
    <div class="d-flex align-center justify-space-between mb-5">
      <div>
        <div class="page-title mb-2 d-flex align-center gap-12">
          <div>เเก้ไขข้อมูลการเปิดรอบเเผนงาน</div>

          <Iconify
              size="30px"
              icon="material-symbols:edit"
              color="var(--theme-color-seven)"
          ></Iconify>
        </div>
      </div>
    </div>

    <divcard class="mb-5">
      <div style="position: relative;">
        <div class="budget-tag tag-pos">
          <div>ปี งปม.</div>
          <div>{{ projectInfo.fiscal_year }}</div>
        </div>

        <div class="card-part pt-0 d-flex flex-column gap-12" style="border-color: var(--theme-color-one)">
          <div class="txt-head">
            ข้อมูลทั่วไป
          </div>

          <div class="d-flex gap-12">
            <div class="flex font-type-bold" style="min-width: 140px; max-width: 140px">
              โครงการหลัก
            </div>
            <div class="flex">
              {{ projectInfo.name }}
            </div>
          </div>

          <div class="d-flex gap-12">
            <div class="flex font-type-bold" style="min-width: 140px; max-width: 140px">
              วันที่เปิดรับโครงการ
            </div>
            <div class="flex">
              {{ toDateRangeFormat(projectInfo.start_date, projectInfo.end_date) }}
            </div>
          </div>

          <div class="d-flex gap-12">
            <div class="flex font-type-bold" style="min-width: 140px; max-width: 140px">
              วันที่พิจารณาโครงการ
            </div>
            <div class="flex">
              {{ toDateFormat(projectInfo.consider_date) }}
            </div>
          </div>

          <div class="d-flex gap-12">
            <div class="flex font-type-bold" style="min-width: 140px; max-width: 140px">
              งบประมาณ
            </div>
            <div class="flex">
              {{ formatNumber(projectInfo.budget, 2) }}
            </div>
          </div>

        </div>

        <div class="card-part d-flex flex-column gap-12">
          <div class="d-flex gap-12">
            <div class="flex font-type-bold" style="min-width: 140px; max-width: 140px">
              รหัสแผนงาน
            </div>
            <div class="flex">
              {{ planInfo.plan_master?.plan_code }}
            </div>
          </div>

          <div class="d-flex gap-12">
            <div class="flex font-type-bold" style="min-width: 140px; max-width: 140px">
              แผนงาน
            </div>
            <div class="flex">
              {{ planInfo.plan_master?.plan_name_th }}
            </div>
          </div>

          <div class="d-flex gap-12">
            <div class="flex font-type-bold" style="min-width: 140px; max-width: 140px">
              หลักการและเหตุผล
            </div>
            <div class="flex" v-html="planInfo.principle?.replace(/\n/g, '<br>')">
            </div>
          </div>

          <div class="d-flex gap-12">
            <div class="flex font-type-bold" style="min-width: 140px; max-width: 140px">
              วัตถุประสงค์
            </div>
            <div class="flex" v-html="planInfo.objective?.replace(/\n/g, '<br>')">
<!--              <div>1) เพื่อยกระดับความสามารถทางการวิจัยและพัฒนาเทคโนโลยีของผู้ประกอบการ</div>-->
<!--              <div>2) บริการที่ปรึกษาให้แก่ผู้ประกอบการภาคอุตสาหกรรมด้วยการนําเทคโนโลยีเข้าไปทําให้เกิด นวัตกรรมในการพัฒนาเทคโนโลยีการผลิต พัฒนาผลิตภัณฑ์ใหม่ เทคนิค ปรับปรุงประสิทธิภาพกระบวนการผลิต พัฒนาคุณภาพสินค้าให้ได้มาตรฐาน การเสาะหาเทคโนโลยีเพื่อให้สามารถเข้าสู่การแข่งขันในตลาดการค้าสากลได้ อย่างเข้มแข็ง รวมถึงการเข้าถึงการให้บริการทางด้านทรัพย์สินทางปัญญา ร่วมกับผู้เชี่ยวชาญเฉพาะทาง</div>-->
<!--              <div>3) เพิ่มช่องทางและการเข้าถึงการพัฒนาเทคโนโลยีของผู้ประกอบการให้มีความหลากหลายมากขึ้น</div>-->
<!--              <div>4) เพื่อสร้างฐานผู้ใช้บริการอุทยานวิทยาศาสตร์ในอนาคต</div>-->
<!--              <div>5) เพื่อเป็นช่องทางในการประชาสัมพันธ์การบริการต่างๆ ของอุทยานวิทยาศาสตร์</div>-->
            </div>
          </div>

          <div class="d-flex gap-12">
            <div class="flex font-type-bold" style="min-width: 140px; max-width: 140px">
              เป้าหมาย
            </div>
            <div class="flex" v-html="planInfo.target?.replace(/\n/g, '<br>')">
<!--              <div>1) สร้างผู้ประกอบการที่มีความสามารถทางเทคโนโลยีและสามารถริเริ่มต่อยอดการวิจัยได้เอง</div>-->
<!--              <div>2) สร้างฐานผู้ใช้บริการอุทยานวิทยาศาสตร์ภูมิภาคในอนาคตและเกิดการใช้บริการต่างๆของ อุทยานวิทยาศาสตร์ภูมิภาคอย่างต่อเนื่อง</div>-->
<!--              <div>3) เพิ่มช่องทางและการเข้าถึงการพัฒนาเทคโนโลยีให้มีความหลากหลายเพิ่มมากขึ้น</div>-->
<!--              <div>4) มีเครือข่ายผู้เชี่ยวชาญนักวิจัยด้านวิทยาศาสตร์และเทคโนโลยีที่สามารถเชื่อมโยงเพื่อแก้ไขปัญหาของผู้ประกอบการในภาคอุตสาหกรรม</div>-->
            </div>
          </div>

          <div class="d-flex gap-12">
            <div class="flex font-type-bold" style="min-width: 140px; max-width: 140px">
              เงื่อนไข
            </div>
            <div class="flex" v-html="planInfo.condition?.replace(/\n/g, '<br>')">
<!--              <div>1) ระยะเวลาโครงการ 1-12 เดือน หรือภายในปีงบประมาณ</div>-->
<!--              <div>2) งบประมาณในการดำเนินโครงการ IRTC ต้องได้รับการสนับสนุนจาก 2 ส่วนได้แก่</div>-->
<!--              <div style="text-indent: 12px">2.1) อุทยานวิทยาศาสตร์สนับสนุนไม่เกินร้อยละ 50 ของค่าใช้จ่ายที่เกิดขึ้นในโครงการ IRTC หรือไม่เกินวงเงิน 400,000 บาทต่อโครงการ</div>-->
<!--              <div style="text-indent: 12px">2.2) อุทยานวิทยาศาสตร์สนับสนุนไม่เกินร้อยละ 50 ของค่าใช้จ่ายที่เกิดขึ้นในโครงการ IRTC หรือไม่เกินวงเงิน 400,000 บาทต่อโครงการ</div>-->
            </div>
          </div>

          <div class="d-flex gap-12">
            <v-layout
                align-center
                class="mt-3"
                v-for="(file, f) in planInfo.attachment"
                :key="f"
            >
              <v-flex shrink>
                <v-btn
                    depressed
                    dark
                    rounded
                    width="125"
                    color="#F15A29"
                    @click="downloadFile(file)"
                >
                  <Iconify
                      style="color: #fff"
                      icon="system-uicons:download"
                  ></Iconify>
                  <span class="font-12 font-w-700">ดาวน์โหลด</span>
                </v-btn>
              </v-flex>
              <v-flex shrink ml-3>
                {{ file.file_name }}
              </v-flex>
            </v-layout>
          </div>

<!--          <div class="d-flex gap-12">-->
<!--            <div class="flex font-type-bold" style="min-width: 140px; max-width: 140px">-->
<!--              หน่วยงาน-->
<!--            </div>-->
<!--            <div class="flex">-->
<!--              สำนักงานปลัดกระทรวงอุดมศึกษาฯ  (สป.อ.ว)ที่-->
<!--            </div>-->
<!--          </div>-->

        </div>
      </div>
    </divcard>

    <div  v-if='planInfo?.plan_master_id !== 5 && planInfo?.plan_master_id !== 6' class="d-flex justify-end mb-3">
      <Button
          theme="6"
          @onClick="addNewRange"
      >
        + เพิ่มรอบเปิดรับโครงการ
      </Button>
    </div>
    <div v-if='planInfo?.plan_master_id !== 5 ' class="d-flex flex-column gap-12 mb-5">
      <divcard
          v-for="(item, i) in allRange"
          :key="i"
      >
        <div class="mb-3">
          <div class="txt-head">รอบที่ {{ item.round }}</div>
        </div>

        <div>
          <div class="flex-center gap-16">
            <div class="flex xs3">
              <div class="mb-1 black--text">วันที่เปิดรับโครงการ</div>
              <DatePicker
                  :value="item.only_start_date"
                  :minDate="projectStartDate"
                  :maxDate="projectEndDate"
                  @onInput="item.only_start_date = $event; $forceUpdate()"
              ></DatePicker>
            </div>

            <div class="flex xs3">
              <div class="mb-1 black--text">เวลา</div>
              <TimePicker
                  :value="item.only_start_time"
                  @onInput="item.only_start_time = $event; $forceUpdate()"
              ></TimePicker>
            </div>

            <div class="flex xs3">
              <div class="mb-1 black--text">ถึง</div>
              <DatePicker
                  :value="item.only_end_date"
                  :minDate="item.only_start_date || projectStartDate"
                  :maxDate="projectEndDate"
                  @onInput="item.only_end_date = $event; $forceUpdate()"
              ></DatePicker>
            </div>

            <div class="flex xs3">
              <div class="mb-1 black--text">เวลา</div>
              <TimePicker
                  :value="item.only_end_time"
                  @onInput="item.only_end_time = $event; $forceUpdate()"
              ></TimePicker>
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex xs3">
              <div class="mb-1 black--text">วันที่พิจารณาโครงการ</div>
              <DatePicker
                  :value="item.consider_date"
                  :minDate="item.only_start_date || projectStartDate"
                  @onInput="item.consider_date = $event; $forceUpdate()"
              ></DatePicker>
            </div>

            <div class="flex xs9">
              <div class="mb-1 black--text">งบประมาณ</div>
              <TextField
                  theme="3"
                  input-type="decimal"
                  :value="item.budget"
                  isFormat
                  @onChange="item.budget = $event"
              ></TextField>
            </div>
          </div>
        </div>
      </divcard>
    </div>

    <div v-if='planInfo?.plan_master_id !== 5  && planInfo?.plan_master_id !== 6' class="d-flex justify-end gap-16">
      <Button
          min-width="80px"
          theme="2"
          @onClick="onCancel"
      >ยกเลิก
      </Button>

      <Button
          min-width="80px"
          @onClick="savePlan"
      >บันทึก
      </Button>
    </div>

  </div>
</template>

<script>
import Button from "../../components/input/Button"
import TextField from "../../components/input/TextField"
import DatePicker from "../../components/input/DatePicker"
import TimePicker from "../../components/input/TimePicker"
import AvailablePlanListItem from "../../components/AvailablePlanListItem"
import { toDateRangeFormat, toDateFormat, formatNumber } from "../../plugins/global-funcs"
import {apiDomain} from "@/store/constants";
import axios from "axios";

export default {
  name: "AvailablePlanList",
  components: {
    TextField,
    AvailablePlanListItem,
    Button,
    DatePicker,
    TimePicker
  },
  data () {
    return {
      toDateRangeFormat,
      toDateFormat,
      formatNumber,
      projectInfo: {},
      planInfo: {},
      allRange: [
        // {
        //   start_date: undefined,
        //   end_date: undefined,
        //   consider_date: undefined,
        //   budget: 0,
        //   round: 1
        // }
      ],
      tempDateTime: {}
    }
  },
  watch: {
    //watch only_start_time in allRange
    'allRange': {
      handler: function (val) {
        val.forEach((item, i) => {
          if (item.only_start_time) {
            if(this.projectInfo.start_date.split(' ')[0] === item.only_start_date) {
              if(item.only_start_time < this.projectInfo.start_date.split(' ')[1]) {
                this.allRange[i].only_start_time = this.projectInfo.start_date.split(' ')[1]
              }
            }
          }
          if(item.only_end_time) {
            if(this.projectInfo.end_date.split(' ')[0] === item.only_end_date) {
              if(item.only_end_time > this.projectInfo.end_date.split(' ')[1]) {
                this.allRange[i].only_end_time = this.projectInfo.end_date.split(' ')[1]
              }
            }
          }
        })
      },
      deep: true
    },
  },
  created () {
    if (!this.$route.query.id) return this.$router.push({ name: 'AvailablePlan' })
    this.getPlanForEdit(this.$route.query.id)
  },
  computed: {
    projectStartDate () {
      console.log('projectStartDate', this.projectInfo.start_date.split(' ')[0])
      return this.projectInfo.start_date ? this.projectInfo.start_date.split(' ')[0] : undefined
    },
    projectEndDate () {
      console.log('projectEndDate', this.projectInfo.end_date.split(' ')[0])
      return this.projectInfo.end_date ? this.projectInfo.end_date.split(' ')[0] : undefined
    },
  },
  methods: {
    addNewRange () {
      this.allRange.push({
        start_date: undefined,
        end_date: undefined,
        consider_date: undefined,
        only_start_time: '00:00',
        only_end_time: '23:59',
        budget: 0,
        round: this.allRange.length + 1
      })
    },
    async getPlanForEdit (id) {
      let res = await this.$apiFire('Plan/getPlanForEdit', id)
      console.log(res)
      if (res) {
        this.projectInfo = res.main_project
        this.planInfo = res.plan
        this.allRange = res.project_accept_rounds.map(x => ({
          ...x,
          only_start_date: x.start_date ? x.start_date.split(' ')[0] : undefined,
          only_start_time: x.start_date ? x.start_date.split(' ')[1] : undefined,
          only_end_date: x.end_date ? x.end_date.split(' ')[0] : undefined,
          only_end_time: x.end_date ? x.end_date.split(' ')[1] : undefined
        }))
      } else {
        this.$router.push({ name: 'AvailablePlan' })
      }
    },
    async savePlan () {
      let payload = {
        id: this.$route.query.id,
        data: this.allRange.map(x => ({
          ...x,
          start_date: x.only_start_date + ' ' + x.only_start_time,
          end_date: x.only_end_date + ' ' + x.only_end_time,
          only_start_date: undefined,
          only_start_time: undefined,
          only_end_date: undefined,
          only_end_time: undefined
        }))
      }
      console.log('payload: ', payload)
      let res = await this.$apiFire('Plan/editPlan', payload, true)
      console.log(res)

      if (res && res.message) {
        this.$store.commit('General/setModal', {
          title: 'เสร็จสิ้น!',
          theme: 'success',
          text: res.message,
          showCancel: false,
          action: () => this.onCancel()
        })
      } else {
        // this.$store.commit('General/setModal', {
        //   title: 'ข้อมูลไม่ครบถ้วน ?',
        //   theme: 'warning',
        //   text: typeof res === 'object' ? res.join(', ') : res,
        //   showCancel: false,
        //   buttonText: 'ตกลง'
        // })
      }
    },
    onCancel () {
      this.$router.push({ name: 'AvailablePlanList', query: { id: this.projectInfo.id } })
    },
    downloadFile(file) {
      axios({
        url: `/api/download/${file.id}`,
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', file.file_name);
        document.body.appendChild(link);
        link.click();
      })
          .catch((error) => {
            this.$store.commit('General/setModal', {
              title: 'ระบบไม่พบไฟล์ที่ร้องขอ',
              theme: 'warning',
              text: 'กรุณาติดต่อเจ้าหน้าที่',
              showCancel: false,
              buttonText: 'ตกลง'
            })
          });
    },
  }
}
</script>

<style scoped lang="scss">
.list-layout {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.tag-pos {
  position: absolute;
  top: 0;
  right: 0;
}
</style>